module.exports = __webpack_public_path__ + "static_1706175070126/img/openup_new.61d1c43f.png";